// extracted by mini-css-extract-plugin
module.exports = {"body":"Homestyle_body__3_3NX","start":"Homestyle_start__2mmS8"};